import React from 'react'
import { Routes, Route } from 'react-router-dom'
import OverView from './pages/overview'
import SignIn from './pages/signin/signin'
import NotFound from './pages/NotFound'
import PublicRoute from './routes/PublicRoute'
import ProtectedRoute from './routes/ProtectedRoute'
import { MSALHandler } from './utils/msal-handler'
import LinkAccounts from './pages/link-accounts/link-accounts'
import BusinessAccounts from './pages/business-accounts/business-accounts'
import ManageAdvertiser from './pages/manage-advertiser/manage-advertiser'
import { BusinessDetails } from './pages/business-accounts/diagnostics'
import Logout from './pages/logout/logout'

function App() {
  return (
    <div className="UPA-APP container">
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <OverView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/overview"
          element={
            <ProtectedRoute>
              <OverView />
            </ProtectedRoute>
          }
        />

        <Route
          path="/link-accounts"
          element={
            <ProtectedRoute>
              <LinkAccounts />
            </ProtectedRoute>
          }
        />

        <Route
          path="/business-accounts"
          element={
            <ProtectedRoute>
              <BusinessAccounts />
            </ProtectedRoute>
          }
        />

        <Route
          path="/business-accounts/:id"
          element={
            <ProtectedRoute>
              <BusinessDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path="/manage-advertiser"
          element={
            <ProtectedRoute>
              <ManageAdvertiser />
            </ProtectedRoute>
          }
        />

        <Route
          path="/sign-in"
          element={
            <PublicRoute>
              <SignIn />
            </PublicRoute>
          }
        />
        <Route path="/signout" element={<Logout redirect="/sign-in" />} />
        <Route path={'/msauthenticate'} element={<MSALHandler />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  )
}

export default App
